
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#fff","d":"M440 368a24.028 24.028 0 0024-24V104a24.028 24.028 0 00-24-24H72a24.028 24.028 0 00-24 24v240a24.028 24.028 0 0024 24zM80 112h352v224H80zM16 400h480v32H16z"}})])
          )
        }
      }
    